import { Link } from 'react-router-dom';
import { de } from '@fsv/core';
import { useOptionalTenant } from '../data/hooks';
import { tx } from '@fsv/data';
import { tenantPath } from '../lib/tenantRouting';
import { helpPath } from '../help/HelpLink';
import { version } from '../version';

/**
 * Product name, the privacy page (the active club's, inside a club), Impressum,
 * terms of use, help and which
 * build is running. Compare the build with /api/health: a mismatch means a
 * half-finished deployment.
 */
export function Footer() {
  const tenant = useOptionalTenant();
  return (
    <footer className="app__footer" data-testid="version-stamp">
      {de.app.name} · <Link to={tenant ? tenantPath(tenant.slug, '/datenschutz') : '/datenschutz'}>{tx.login.privacyLink}</Link> ·{' '}
      <Link to="/impressum">Impressum</Link> · <Link to="/nutzungsbedingungen">{tx.login.termsLink}</Link> ·{' '}
      <Link to={helpPath(tenant?.slug)}>{tx.help.title}</Link> ·{' '}
      {de.footer.version(version.build, version.commit, version.builtAt)}
    </footer>
  );
}
